(function() {
  'use strict';

  window.CologneCapitol = window.CologneCapitol || {};
  window.dataLayer = window.dataLayer || [];

  // ── MOBILE NAV ───────────────────────────────
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      const open = mobileNav.classList.toggle('open');
      this.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // ── CART COUNT ───────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── AJAX ADD TO CART ────────────────────────
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('#product-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.style.opacity = '0.7'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(r => r.json())
      .then(item => {
        if (btn) { btn.textContent = 'Added ✓'; btn.style.background = '#4a7c59'; }
        updateCartCount();
        if (window.CCCart) { window.CCCart.open(); }
        setTimeout(() => {
          if (btn) { btn.textContent = original; btn.style.background = ''; btn.style.opacity = '1'; btn.disabled = false; }
        }, 2200);
      })
      .catch(() => { if (btn) { btn.textContent = original; btn.style.opacity = '1'; btn.disabled = false; } });
  });

  // ── ANNOUNCEMENT BAR DISMISS ───────────────────
  const announceDismiss = document.getElementById('announce-dismiss');
  if (announceDismiss) {
    announceDismiss.addEventListener('click', function() {
      const bar = this.closest('.announcement-bar');
      if (bar) bar.style.display = 'none';
      sessionStorage.setItem('cc_announce_dismissed', '1');
    });
    if (sessionStorage.getItem('cc_announce_dismissed')) {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

  // ── STICKY HEADER ON SCROLL ───────────────────
  const siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const current = window.scrollY;
      if (current > 80) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
      lastScroll = current;
    }, { passive: true });
  }

  // ── SMOOTH SCROLL FOR ANCHOR LINKS ──────────────
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── IMAGE LAZY LOAD FALLBACK ──────────────────
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImages.forEach(img => observer.observe(img));
  }

  // ── BACK TO TOP ──────────────────────────────
  const btt = document.getElementById('back-to-top');
  if (btt) {
    window.addEventListener('scroll', () => {
      btt.style.opacity = window.scrollY > 400 ? '1' : '0';
      btt.style.pointerEvents = window.scrollY > 400 ? 'auto' : 'none';
    }, { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

})();
